export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9299.4a8a5d97.jpg";